import {Component} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';

import {AuthService} from 'app/user/auth.service';
import {EnvironmentService} from 'app/services/environment.sevice';
import {camelCase} from 'app/core/case-transform';
import {validate} from 'app/user/form.functions';

interface PasswordRecovery {
    email: string,
    resetPasswordUrl: string
}

@Component({
    selector: 'password-recover',
    templateUrl: 'password-recover.component.html',
    styleUrls: ['password-recover.component.scss']
})
export class PasswordRecoverComponent {

    error: string;
    processing: boolean;
    submitted: boolean;
    model: PasswordRecovery;

    constructor(environmentService: EnvironmentService,
                private _router: Router,
                private _authService: AuthService) {
        this.model = {
            email: '',
            resetPasswordUrl: environmentService.mainServer + '/password/change/%7Btoken%7D'
        };
    }

    onSubmit(form: NgForm) {
        if (form.invalid) {
            return;
        }

        this.error = null;
        this.processing = true;

        this._authService
            .recoverPassword(this.model.email, this.model.resetPasswordUrl)
            .subscribe(() => this._onSuccess(), (error) => this._onError(error));
    }

    onOk() {
        this.processing = true;
        this._router.navigateByUrl('/login');
    }

    validate(form: NgForm) {
        validate(form);
    }

    onHideError() {
        this.error = null;
    }

    private _onSuccess() {
        this.processing = false;
        this.submitted = true;
    }

    private _onError(response) {
        if (response.status === 400) {
            const responseJson = response.json();
            this.error = camelCase(responseJson.error);
        }

        if (response.status === 403) {
            this.error = 'userIsBlocked';
        }

        if (response.status === 404) {
            this.error = 'userNotExists';
        }

        if (response.status === 409) {
            this.error = 'userNotActivated';
        }

        this.processing = false;
    }
}
